/**
 * @file 上传文件api
 * @author yinfangyan(yinfangyan@baidu.com)
 */

import {post} from '@/utils/decorate/request';
import {Url} from '@/utils/api.js';

export default function uploadFile(file) {
    const formData = new FormData();
    formData.append('contentFile', file);
    // 图片上传
    return post(Url.uploadFileUrl, formData, {
        'Content-type': 'multipart/form-data'
    }
    );
}
